import { getAuth } from 'firebase/auth'
import { format, parseISO, startOfDay, endOfDay} from 'date-fns'
import helpers from '@/helpers'

export default {
  name: 'booking-modal',
  components: {
    Keypress: () => import('vue-keypress')
  },
  props: {
    resource: {
      required: true
    },
    date: {
      required: true
    },
    availability: {
      required: true
    },
    selectedDate: {
      required: true
    }
  },
  data () {
    return {
      startTime: this.date,
      view: {
        loading: true,
        loadingData: false,
        show: false
      },
      hydratedRes: null
    }
  },
  computed: {
    dayBeginning () {
      return startOfDay(parseISO(this.selectedDate)).getTime()
    },
    user () {
      return this.$store.getters.userData
    },
    org () {
      return this.$store.getters.activeOrg
    },
    status () {
      if(this.availability['bookedByUser'].includes(this.resource.id)) {
        return "bookedByUser"
      }
      if(this.availability["unavailable"].includes(this.resource.id)){
        return "unavailable"
      }
      return "available"
    },
    fullResource () {
      return this.hydratedRes || this.resource
    }
  },
  async mounted () {
    console.log('bookingModal mounted, resource:', this.resource);
    this.view.show = true
    this.view.loading = false

    if(!this.resource.loadedData) {
      console.log("resource needs to be loaded")
      this.view.loadingData = true
      this.fetchData()
    }


    setTimeout(() => {
      // focus the main CTA      
      this.$refs.mainCTA.focus()
    }, 1000);
  },
  methods: {
    async fetchData () {
      this.hydratedRes = await this.$store.dispatch("fetchDocData", {
        id: this.resource.id,
        collection: "resources",
      });
    },
    async cancelReservation (resource) {
      console.log("cancelling reservation for resource:", resource);

      this.view.loading = true

      try {
        const auth = getAuth();
        const user = auth.currentUser;
        let token = await user.getIdToken(user, true)

        console.log('this.dayBeginning:', this.dayBeginning);
        console.log('resource.reservations.onceOff:', resource.reservations.onceOff);
        

        // find the reservation we wanna cancel
        let reservation = resource.reservations.onceOff.filter(res => {
          return res.startTime === this.dayBeginning
        })[0]

        if(!reservation){
          console.log('NO RESERVATION FOUND')
          throw "Error, no reservation found... :/"
        }

        let obj = {
          token: token, 
          org: this.org.id,
          resource: resource.id,
          reservationId: reservation.id,
          email: this.user.email,
          uid: this.user.id
        }

        console.log('obj to post:', obj);

        let res = await fetch('/api/cancelreservation', {
          method: 'post',
          body: JSON.stringify(obj),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })

        res = await res.json();
        console.log('res:', res);

        if(!res.error){

          this.$store.dispatch("updateDoc", {
            data: new helpers.Resource(res.data),
            action: "update",
            docType: 'resources',
            fullDoc: true
          });

          this.$toast.success(`Cancelled: ${resource.name}`);

        } else {
          throw res.message
        }

      } catch (error) {
        console.log("error cancelling reservation:", error)
        this.$toast.error("Error: "+error);
      } finally {
        // fetch the newest data from DB - necessary for error AND success
        this.view.loading = false
      }

    },
    formatDate(date){
      return format(parseISO(date), "dd MMM yyyy")
    },
    async bookResource () {

      // for the selected date, get the 00:00 00:00am epoch value
      // and then add on 24 hours. Those are the start and end times
      this.view.loading = true
      let start = startOfDay(parseISO(this.startTime)).getTime()
      let end = endOfDay(start).getTime()

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true)

      let obj = {
        id: helpers.generateID(),
        token: token, 
        org: this.org.id,
        resource: this.resource,
        email: this.user.email,
        uid: this.user.id,
        slot: {
          startTime: start,
          endTime: end
        }
      }

      // console.log('obj to post:', obj);

      let res = await fetch('/api/reserveresource', {
        method: 'post',
        body: JSON.stringify(obj),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      res = await res.json();

      if(!res.error){
        console.log('res:', res);
        
        // updated resource data will be in the response, update the store
        this.$store.dispatch("updateDoc", {
          data: new helpers.Resource(res.data),
          action: "update",
          docType: 'resources',
          fullDoc: true
        });
        
        this.$toast.success(`${this.resource.name} reserved for ${this.formatDate(this.startTime)}`);

        this.$emit('close', true);

      } else {
        console.log("error booking resource:", res.message)
        this.$toast.error("Error: "+res.message);
        this.view.loading = false
      }

    },
    async slideClosed () {
      this.view = false
      await helpers.wait(75)
      this.$emit("close", false);
    }
  }
}
